/* Svensk katalog for locale-invoice-list-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'listControl.dialog': 'Stäng den öppna dialogen innan chatten fortsätter med fakturalistan.',
  'live.set_document_type': 'Väljer dokumenttyp …',
  'listControl.alreadyDone': 'Åtgärden har redan utförts för det här dokumentet i den här förfrågan.',
  'listControl.choice.attachment': 'PDF-bilaga',
  'listControl.choice.link': 'Länk',
  'listControl.choice.reminder': 'Betalningspåminnelse',
  'listControl.choice.purring': 'Påminnelse',
  'listControl.working': 'Arbetar med fakturalistan …',
  'listControl.unavailable': 'Fakturalistan är inte klar. Öppna sidan och försök igen.',
  'listControl.selection': 'Välj entydiga dokument från sökresultatet, högst 20 åt gången.',
  'listControl.changed': 'Listan eller urvalet har ändrats. Sök och välj dokumenten på nytt.',
  'listControl.invalid': 'Åtgärden saknar giltiga detaljer.',
  'listControl.ineligible': 'Den här åtgärden passar inte för alla valda dokument.',
  'listControl.reason': 'Ange orsaken till krediteringen.',
  'listControl.reminder': 'Välj en obetald faktura, typ av påminnelse och nytt förfallodatum. Utskicket sker utan avgift.',
  'listControl.payment': 'Ange belopp inom utestående, betalningsdatum och betalkonto för en faktura.',
  'listControl.conversion': 'Välj en färdig offert utan tidigare konverteringar. Använd Skapa på sidan om du behöver en extra konvertering.',
  'listControl.uncertain': 'Resultatet är inte bekräftat. Kontrollera dokumentet före ett nytt försök; chatten försöker inte automatiskt igen.',
  'listControl.unsaved': 'Spara eller stäng det öppna utkastet innan du byter dokument.',
  'listControl.stopped': 'Resten av urvalet utfördes inte.',
  'listControl.done.searched': 'Sökningen visas i fakturalistan.',
  'listControl.done.selected': 'Dokumenten är valda i listan.',
  'listControl.done.opened': 'Dokumentet är öppnat.',
  'listControl.done.unsaved': 'Utkastet är öppnat och har inte sparats än.',
  'listControl.done.prepared': 'Åtgärden och detaljerna visas nedan.',
  'listControl.done.sent': 'Skickat.',
  'listControl.done.paid': 'Betalningen har registrerats.',
  'listControl.done.deleted': 'Utkastet har tagits bort.',
  'listControl.done.archived': 'Arkiverat.',
  'listControl.done.restored': 'Hämtat från arkivet.',
  'listControl.done.creditDraft': 'Kreditfakturan har sparats som utkast.',
  'listControl.done.issued': 'Dokumentet har skapats.',
  'listControl.operation.send': 'Skicka dokument',
  'listControl.operation.reminder': 'Skicka påminnelse utan avgift',
  'listControl.operation.credit': 'Kreditera',
  'listControl.operation.archive': 'Arkivera',
  'listControl.operation.restore': 'Hämta från arkivet',
  'listControl.operation.delete_draft': 'Ta bort utkast',
  'listControl.operation.register_payment': 'Registrera betalning',
  'listControl.operation.issue_draft': 'Skapa dokument',
  'listControl.option.recipientEmail': 'Mottagare',
  'listControl.option.deliveryMode': 'Leveranssätt',
  'listControl.option.variant': 'Typ',
  'listControl.option.dueDate': 'Förfallodatum',
  'listControl.option.comment': 'Kommentar',
  'listControl.option.creditReason': 'Orsak',
  'listControl.option.issue': 'Skapa färdig kreditfaktura',
  'listControl.option.amount': 'Belopp',
  'listControl.option.date': 'Betalningsdatum',
  'listControl.option.settlementAccountCode': 'Betalkonto',
  'listControl.option.note': 'Anteckning',
  'live.done.set_document_type': 'Dokumenttypen är vald.',
});
